import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import styles from './InterestCard.module.sass'

const LazyLoadImage = React.lazy(() =>
  import('react-lazy-load-image-component').then(module => ({
    default: module.LazyLoadImage
  }))
)

const InterestCard = ({
  thumbnail,
  credit,
  creditType,
  title,
  description,
  url,
  alt
}) => {
  const isHTML = description?.startsWith('<p>')

  return (
    <div className={styles.card}>
      <div style={{ minWidth: '100px' }}>
        <a href={url} target="_blank" rel="noreferrer">
          <Suspense fallback={''}>
            <LazyLoadImage
              src={thumbnail}
              className={styles.img}
              effect="opacity"
              alt={alt}
            />
          </Suspense>
        </a>
      </div>
      <div className={styles.detail}>
        {creditType && creditType?.toUpperCase() !== 'IME' && (
          <p className={styles.credit}>
            {creditType?.toUpperCase() === 'EBAC-CE'
              ? `${creditType}`
              : `${credit} ${creditType}`}
          </p>
        )}
        <a
          dangerouslySetInnerHTML={{ __html: title }}
          href={url}
          target="_blank"
          rel="noreferrer"
          className={styles.title}
        />
        {isHTML ? (
          <span
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html:
                description.substring(-3, description.length - 4) +
                '...' +
                `<a href="` +
                url +
                `" style="margin-left:5px;" class="readmoreLink" target="_blank" rel="noreferrer">read more</a>` +
                '</p>'
            }}
          />
        ) : (
          <p className={styles.description}>
            {description ? description + '...' : ''}
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className={styles.readmore}
            >
              read more
            </a>
          </p>
        )}
      </div>
    </div>
  )
}

InterestCard.propTypes = {
  thumbnail: PropTypes.string,
  credit: PropTypes.string,
  creditType: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  alt: PropTypes.string
}

export default InterestCard
